















import Vue from 'vue'
import { CopyToClipboardElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'CopyToClipboardEl',

  data: () => ({
    snackbar: false
  }),

  props: {
    templateItemData: {
      type: Object as () => CopyToClipboardElInterface,
      required: true
    }
  },

  methods: {
    copyValueData (): void {
      this.snackbar = true
      navigator.clipboard.writeText(this.$props.templateItemData.value.trim())
    }
  }
})
